module.exports = __webpack_public_path__ + "static/media/overview3_1.b7cc5911.png";